import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="enable-submit"
export default class extends Controller {
  static values = {
    accepted: Boolean,
  };

  static targets = ["mandatoryField", "submitButton"];

  connect() {
    this.verifyEnabling();
  }

  verifyEnabling() {
    if (this.hasAcceptedValue) {
      this.submitButtonTarget.disabled =
        this.mandatoryFieldTarget.checked !== this.acceptedValue;
      return;
    }

    this.allMandatoriesFilled = this.mandatoryFieldTargets.every(
      (field) => field.value !== "",
    );

    const action = this.element.dataset.formAction;
    this[`${action || "new"}Verification`]();
  }

  newVerification() {
    this.submitButtonTarget.disabled = !this.allMandatoriesFilled;
  }

  editVerification() {
    const fields = this.element.querySelectorAll(
      "input:not([type='hidden']), select, textarea",
    );
    const hasChangedValue = Array.from(fields).some(
      (field) => field.value !== field.dataset.currentValue,
    );
    this.submitButtonTarget.disabled = !(
      this.allMandatoriesFilled && hasChangedValue
    );
  }
}
